import React, { Component } from 'react';

class SearchSucursalModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            selectAll: false
        };
    }
    onChangeField = (keyVal, value) => {
        this.setState({
            [keyVal]: value
        })
    }
    render() {
        const { action, sucursales, SearchSucursal, editMode, SaveModules, CloseSearchSucursalModal } = this.props;
        const filtered = sucursales?.filter(s =>
            s.nombre?.toLowerCase().includes(this.state.search.toLowerCase())
        );
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="searchSucursalModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="searchSucursalModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Sucursales</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseSearchSucursalModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 d-flex align-items-center">
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Buscar Sucursal..."
                                                value={this.state.search}
                                                onChange={(e) => this.onChangeField('search', e.target.value)}
                                            />

                                        </div>
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre de la sucursal</td>
                                                    <td className="sticky-header table-header-yellow"
                                                        style={{ width: 50, textAlign: "center" }}>
                                                    </td>
                                                </tr>
                                                {!!filtered && filtered.map((sucursal, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{sucursal.nombre}</td>
                                                            <td className="sticky-column">
                                                                <button type="button" className="btn botonCorrect"
                                                                    onClick={() => SearchSucursal(sucursal.pk_Sucursal)}>
                                                                    Seleccionar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseSearchSucursalModal}>
                                Cerrar
                            </button>
                            {action === 1 && !editMode &&
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveModules}>
                                    Guardar
                                </button>
                            }
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveModules}>
                                    Actualizar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchSucursalModal;